import { createStore } from 'vuex'

const updateModule = {
  namespaced: true,
  state() {
    return {
      isUpdate: false // 建议使用驼峰命名
    }
  },
  mutations: {
    setUpdate(state, payload) {
      // 建议使用驼峰命名
      state.isUpdate = payload
    }
  },
  actions: {
    toUpdate(context, payload) {
      context.commit('setUpdate', payload)
    }
  }
}

const store = createStore({
  modules: {
    update: updateModule // 模块名改为 update
  }
})

export default store
